<template>
    <div>
        <div class="row">
            <div class="col-xl-4 col-sm-5">
                <input type="text" class="form-control base_input" placeholder="0000000000138024" v-model="order_id"
                       @keypress="isNumber" @keyup.enter="findByOrderId" @keydown="something()"/>
            </div>
            <div>
                <button type="submit" class="btn base_btn solid_blue waves-effect waves-light" @click="findByOrderId()">{{i18n('Check ticket')}}</button>
            </div>
            <div class="col-xl-6 col-sm-4">
                <div class="float-right">
                    <span class="price d-inline-block text-primary font-weight-bold mr-1 pt-2">{{orderPrice}}</span>
                </div>
            </div>
        </div>

        <div :class="{hidden: isFalse}">{{i18n('No reserved places found with this reservation! Check the correct order number')}}</div>

    </div>
</template>

<script>
    export default {
        name: "BookingBuyout",

        data() {
            return {
                order_id: null,
                data: [],
                isFalse: true,
                orderPrice: null,
                unseccessfull_order_id: null,
                unseccessfull: false,
            }
        },
        methods: {
            findByOrderId() {
                if (this.unseccessfull === true)
                    return;
                this.$api.get('cashier.find-by-order', this.order_id)
                    .then(res => {
                        if (res.data === false) {
                            this.unseccessfull_order_id = this.order_id;
                            this.isFalse = false;
                            this.unseccessfull = true;
                            return false;
                        }
                        this.unseccessfull_order_id = null;
                        this.$store.commit('setCashierBasket', res.data);
                        //this.$router.push({name: 'dashboard.two'});
                        this.$router.push('/cashier/dashboard-two/' + res.data.trip_id + '/' + res.data.from + '/' + res.data.to + '/' + true);
                    });
            },
            isNumber(evt) {
                evt = (evt) ? evt : window.event;
                var charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            something() {
                this.isFalse = true;
                this.unseccessfull = false;
            }
        }
    }
</script>

<style scoped>

    .hidden {
        display: none;
    }

</style>
